var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#213366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C7.67695 10 7.35391 9.87438 7.10932 9.6278L4.10037 6.59436C3.96654 6.45944 3.96654 6.23612 4.10037 6.10119C4.23421 5.96627 4.45573 5.96627 4.58956 6.10119L7.5985 9.13463C7.82002 9.35795 8.17998 9.35795 8.4015 9.13463L11.4104 6.10119C11.5443 5.96627 11.7658 5.96627 11.8996 6.10119C12.0335 6.23612 12.0335 6.45944 11.8996 6.59436L8.89068 9.6278C8.64609 9.87438 8.32305 10 8 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableArrowDown);
export default __webpack_public_path__ + "static/media/table-arrow-down.bcc01f16e0924892af980d54098952b9.svg";
export { ForwardRef as ReactComponent };